import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer"; // Import Footer
import SharedNavbar from "../components/SharedNavbar";
import {
  FaUserCheck,
  FaBan,
  FaBrain,
  FaLock,
  FaKey,
  FaHistory,
  FaShieldAlt,
  FaBug,
  FaTimes
} from "react-icons/fa";
import "./SecurityPage.css"; // Import new styles
import "../App.css"; // Keep global styles for Navbar/Footer

const SecurityPage = () => {
  const navigate = useNavigate();

  // Fix scroll issue on mount - REMOVED (Handled globally by ScrollToTop)

  return (
    <div className="security-page">
      {/* Navigation */}
      <SharedNavbar />

      <div className="security-container" style={{ maxWidth: "1200px", margin: "0 auto", padding: "8rem 1.5rem 6rem" }}>

        {/* Header */}
        <header className="security-header">
          <h1>Security & Trust</h1>
          <p>
            MoonshotMap is designed to help you map sensitive ideas without turning your data into someone else’s training set.
          </p>
        </header>

        {/* Declarations Grid */}
        <div className="security-grid">

          <div className="security-card">
            <div className="card-icon-wrapper"><FaUserCheck /></div>
            <h3>Your data is yours</h3>
            <p>You own your prompts, uploads, and maps. You can export or delete your data anytime.</p>
          </div>

          <div className="security-card">
            <div className="card-icon-wrapper"><FaBan /></div>
            <h3>No selling of user data</h3>
            <p>We do not sell user data. We do not allow third parties to advertise using your workspace data.</p>
          </div>

          <div className="security-card">
            <div className="card-icon-wrapper"><FaBrain /></div>
            <h3>Model training</h3>
            <p>We don’t use private workspace data for training unless you explicitly opt in.</p>
          </div>

          <div className="security-card">
            <div className="card-icon-wrapper"><FaLock /></div>
            <h3>Encryption & storage</h3>
            <ul>
              <li>Encryption in transit (TLS).</li>
              <li>Encryption at rest for stored data.</li>
            </ul>
          </div>

          <div className="security-card">
            <div className="card-icon-wrapper"><FaKey /></div>
            <h3>Access controls</h3>
            <p>Minimal internal access on a need-to-know basis. Admin actions are auditable.</p>
          </div>

          <div className="security-card">
            <div className="card-icon-wrapper"><FaHistory /></div>
            <h3>Data retention</h3>
            <ul>
              <li>Active verification of retention policies.</li>
              <li>Data removed from active systems within defined window after deletion.</li>
            </ul>
          </div>

          <div className="security-card">
            <div className="card-icon-wrapper"><FaShieldAlt /></div>
            <h3>Incident response</h3>
            <p>We have an internal process for triage, mitigation, and user notification.</p>
          </div>

          <div className="security-card">
            <div className="card-icon-wrapper"><FaBug /></div>
            <h3>Responsible disclosure</h3>
            <p>Bug reports welcome. Contact: <a href="mailto:security@moonshotmap.com" style={{ color: "#2563eb" }}>security@moonshotmap.com</a></p>
          </div>

        </div>

        {/* "What We Don't Do" Section */}
        <section className="trust-builder">
          <div className="trust-header">
            <h3>What we don’t do</h3>
            <div style={{ height: "2px", flex: 1, background: "#e5e7eb" }}></div>
          </div>

          <div className="trust-grid">
            <div className="trust-item">
              <div className="x-icon"><FaTimes /></div>
              <span className="trust-text">We don’t publish your maps.</span>
            </div>
            <div className="trust-item">
              <div className="x-icon"><FaTimes /></div>
              <span className="trust-text">We don’t share your uploads with other users.</span>
            </div>
            <div className="trust-item">
              <div className="x-icon"><FaTimes /></div>
              <span className="trust-text">We don’t make your private work searchable.</span>
            </div>
          </div>
        </section>

      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default SecurityPage;
